import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { Component, ViewEncapsulation, Injector, ViewChild, OnInit, NgModule } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EventsScheduleDto, EventsServiceProxy } from '@shared/service-proxies/service-proxies';

import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';


@Component({
  templateUrl: './event-schedule.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
})
export class EventScheduleComponent extends AppComponentBase {

  active = false;
  saving = false;
  htmlContent = undefined;
  schedule: EventsScheduleDto = new EventsScheduleDto();

  constructor(
    injector: Injector,
    private _router: Router,
    private sanitizer: DomSanitizer,
    private _eventsService: EventsServiceProxy,
    public permission: PermissionCheckerService

  ) {
    super(injector);
    this.schedule.scheduleHtml = '';
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.getEventsSchedule();
  }


  getEventsSchedule(): void {

    this._eventsService.getEventsScheduleForEdit()
      .subscribe(result => {

        if (result) {
          this.schedule = result;
          this.active = true;
          this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(this.schedule.scheduleHtml);
        }
        else {
          this.active = false;
        }
      });
  }

  updateSchedule(): void {

    this._eventsService.createOrEditEventsSchedule(this.schedule)
      .finally(() => { this.saving = false; })
      .subscribe(() => {
        this.notify.info(this.l('SavedSuccessfully'));
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/event/schedule/event-schedule.component.ts